<template>
    <transition name="dialogfade">
        <k-dialog v-if="showDialog"
            class="edit-condition-dialog bulk-edit-tracking-dialog"
            :title="'Update Tracking'"
            @close="closeDialog">
                <div class="edit-condition__wrapper">
                    <div class="edit-condition__detail-tracking">
                        <section class="add-document__section-detail detail--current-documents">
                            <div class="select-document__wrapper">
                                <h2 class="section--title">Selected Conditions</h2>
                                    <div class="condition-document__container">
                                        <div class="condition-document__row" v-for="condition in selectedConditions" :key="condition.id">
                                            <p class="condition-document__item">
                                                <span class="condition-document__item--name">{{ condition.title }}</span>
                                            </p>
                                        </div>
                                    </div>
                            </div>
                        </section>
                        <section class="edit-condition__section-tracking">
                            <h2 class="section--title">Tracking Status</h2>
                            <div v-for="status in trackingStatus" :key="status.status" v-bind:class="['tracking-checkbox__container']">
                                <k-checkbox @change="checkForTrackingChanges" v-model="status.isChecked" :id="status.status">
                                    <label :for="status.status" class="tracking-status__label">{{ status.status }}</label>
                                </k-checkbox>
                            </div>
                        </section>
                    </div>
                </div>
                <k-dialog-actions>
                    <k-button v-bind:class="['dialog__btn dialog__btn--save', { 'dialog__btn--save-active': !updateTrackingBtnDisabled }]" v-on:click="onUpdateTracking" :disabled="updateTrackingBtnDisabled">Save</k-button>
                    <k-button class="dialog__btn dialog__btn--close" v-on:click="closeDialog">Close</k-button>
                </k-dialog-actions>
        </k-dialog>
    </transition>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { Checkbox } from "@progress/kendo-vue-inputs";
    import { Button } from '@progress/kendo-vue-buttons';

    import isEqual from 'lodash.isequal';
    import cloneDeep from 'lodash.clonedeep';

    export default {
        props: ['selectedConditions', 'showDialog'],
        emits: ['bulktrackingupdated', 'dialogclosed'],
        data() {
            return {
                trackingStatus: [],
                trackingStatusModel: [
                    {
                        status: 'Requested',
                        isChecked: false,
                        user: '',
                        statusDate: ''
                    },
                    {
                        status: 'Re-requested',
                        isChecked: false,
                        user: '',
                        statusDate: ''
                    },
                    {
                        status: 'Fulfilled',
                        isChecked: false,
                        user: '',
                        statusDate: ''
                    },
                    {
                        status: 'Reviewed',
                        isChecked: false,
                        user: '',
                        statusDate: ''
                    },
                    {
                        status: 'Rejected',
                        isChecked: false,
                        user: '',
                        statusDate: ''
                    },
                    {
                        status: 'Cleared',
                        isChecked: false,
                        user: '',
                        statusDate: ''
                    },
                    {
                        status: 'Waived',
                        isChecked: false,
                        user: '',
                        statusDate: ''
                    }
                ],
                updateTrackingBtnDisabled: true
            }
        },
        watch: {
            showDialog(val) {
                if (val) {
                    this.trackingStatus = cloneDeep(this.trackingStatusModel);
                } else {
                    this.trackingStatus = [];
                    this.updateTrackingBtnDisabled = true;
                }
            }
        },
        methods: {
            checkForTrackingChanges() {
                if (isEqual(this.trackingStatus, this.trackingStatusModel)) {
                    return this.updateTrackingBtnDisabled = true;
                }

                this.updateTrackingBtnDisabled = false;
            },
            closeDialog() {
                this.$emit('dialogclosed');
            }, 
            onUpdateTracking() {
                let tracking = this.trackingStatus.filter(status => status.isChecked);

                this.$emit('bulktrackingupdated', tracking);
            }          
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'k-button': Button,
            'k-checkbox': Checkbox
        }
    }
</script>

<style>
    @import '/src/assets/css/bulkEditTrackingDialog.css';
</style>
